module.exports = __webpack_public_path__ + "img/process-5.054e0e63.png";